import script from "./ExamClock.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamClock.vue?vue&type=script&setup=true&lang=js"

import "./ExamClock.vue?vue&type=style&index=0&id=4ae6a26c&scoped=true&lang=css"
import "./ExamClock.vue?vue&type=style&index=1&id=4ae6a26c&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae6a26c"]])

export default __exports__